import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import DealerTableComponent from "../../../Components/Table/DealerTableComponent";

const stockAnalysisApi = async (body) => {
  try {
    const res = await axInst.post("dealer-review/stocks_dashboard", body);
    return res.data;
  } catch (error) {
    console.error("Error fetching stock data:", error.response || error);
    throw error;
  }
};

const StockTable = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  const {
    data: stockData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["stock_data", submitted],
    queryFn: () => stockAnalysisApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  // Define table columns
  const columns = useMemo(
    () => [
      { accessorKey: "category", header: "" },
      {
        accessorKey: "closing_stock_in_month",
        header: "Closing Stock in Month",
      },
      { accessorKey: "Stock_in_days", header: "Stock in Days" },
      { accessorKey: "Stock_above_90_days", header: "Stock Above 90 Days" },
    ],
    []
  );

  const tableData = useMemo(() => {
    if (!stockData || Object.keys(stockData).length === 0) return null;

    const formattedData = Object.entries(stockData).map(([key, values]) => ({
      category: key,
      ...values,
    }));

    const totalClosingStock = parseFloat(
      formattedData
        .reduce((sum, row) => sum + (row.closing_stock_in_month || 0), 0)
        .toFixed(2)
    );
    const totalRetailMonth = parseFloat(
      formattedData
        .reduce((sum, row) => sum + (row.Sum_Retail_Month || 0), 0)
        .toFixed(2)
    );
    const totalStockAbove90 = parseFloat(
      formattedData
        .reduce((sum, row) => sum + (row.Stock_above_90_days || 0), 0)
        .toFixed(2)
    );

    const totalRow = {
      category: "Total",
      closing_stock_in_month: totalClosingStock,
      Stock_in_days: ((totalClosingStock / totalRetailMonth) * 30).toFixed(2),
      Stock_above_90_days: totalStockAbove90,
    };

    return [...formattedData, totalRow];
  }, [stockData]);

  // Handle loading & error states
  if (isFetching)
    return (
      <div className="grid items-center justify-center w-full h-full">
        <Loader />
      </div>
    );
  if (isError) return <div>Error loading data.</div>;
  if (!tableData)
    return (
      <div className="grid items-center justify-center w-full h-full text-gray-500">
        Data not available
      </div>
    );

  // Render the table
  return (
    <DealerTableComponent
      tableData={tableData}
      columns={columns}
      heading="Stock Analysis"
    />
  );
};

export default StockTable;
